import { Cell, VariableDef } from "@/types/resources";

/**
 * Cell-value derivation shared by the section/question read displays. Cells are
 * shown positionally ("Cell 1", "Cell 2", …) rather than labelled by any one
 * variable, so we only derive a thumbnail (first image variable) and a
 * "filled" check here.
 */

export const firstImageVariable = (
  variables: VariableDef[]
): VariableDef | undefined => variables.find((v) => v.type === "image");

/** A cell counts as "filled" once any declared variable carries a value (a
    non-blank text value or a present image key/url). */
export const isCellFilled = (cell: Cell, variables: VariableDef[]): boolean =>
  variables.some(
    (variable) =>
      (cell[`${variable.name}_url`] ?? cell[variable.name] ?? "").trim() !== ""
  );

/**
 * The cell's display image — the presigned `<name>_url` of the first image
 * variable when present, falling back to the raw stored value. Empty string
 * when there's no image slot or it's unfilled.
 */
export const cellImageUrl = (cell: Cell, variables: VariableDef[]): string => {
  const variable = firstImageVariable(variables);
  if (!variable) return "";
  return cell[`${variable.name}_url`] ?? cell[variable.name] ?? "";
};
